// 项目基础数据
export const projects = [
  // 申报书审查 (Step 0)
  {
    id: 1,
    code: '2025AI001',
    name: '基于深度学习的智能诊断系统研究',
    leader: '张明华',
    status: 'inProgress',
    currentStage: '申报书审查',
    currentStep: 0,
    stepStatus: 'inProgress',
    institution: '清华大学',
    startDate: '2025-01-01',
    duration: '36 个月',
    budget: '500 万',
    progress: 35
  },
  {
    id: 2,
    code: '2025AI002',
    name: '自然语言处理在医疗领域的应用',
    leader: '李晓峰',
    status: 'completed',
    currentStage: '申报书审查',
    currentStep: 0,
    stepStatus: 'completed',
    institution: '北京大学',
    startDate: '2025-01-05',
    duration: '24 个月',
    budget: '300 万',
    progress: 25
  },
  {
    id: 3,
    code: '2025AI003',
    name: '计算机视觉在工业检测中的应用',
    leader: '王建国',
    status: 'inProgress',
    currentStage: '申报书审查',
    currentStep: 0,
    stepStatus: 'inProgress',
    institution: '复旦大学',
    startDate: '2025-01-08',
    duration: '30 个月',
    budget: '420 万',
    progress: 20
  },
  // 立项评审 (Step 1)
  {
    id: 4,
    code: '2025BIO001',
    name: '新型抗肿瘤药物筛选平台构建',
    leader: '陈志强',
    status: 'inProgress',
    currentStage: '立项评审',
    currentStep: 1,
    stepStatus: 'inProgress',
    institution: '上海交通大学',
    startDate: '2025-01-10',
    duration: '48 个月',
    budget: '800 万',
    progress: 40
  },
  {
    id: 5,
    code: '2025BIO002',
    name: '基因编辑技术在作物改良中的应用',
    leader: '刘芳',
    status: 'completed',
    currentStage: '立项评审',
    currentStep: 1,
    stepStatus: 'completed',
    institution: '浙江大学',
    startDate: '2025-01-12',
    duration: '36 个月',
    budget: '600 万',
    progress: 45
  },
  {
    id: 6,
    code: '2025BIO003',
    name: '合成生物学在医药领域的创新应用',
    leader: '赵伟',
    status: 'inProgress',
    currentStage: '立项评审',
    currentStep: 1,
    stepStatus: 'inProgress',
    institution: '南京大学',
    startDate: '2025-01-15',
    duration: '42 个月',
    budget: '720 万',
    progress: 38
  },
  // 任务书审查 (Step 2)
  {
    id: 7,
    code: '2025MAT001',
    name: '高性能碳纤维复合材料制备技术',
    leader: '孙丽',
    status: 'inProgress',
    currentStage: '任务书审查',
    currentStep: 2,
    stepStatus: 'inProgress',
    institution: '华中科技大学',
    startDate: '2025-01-18',
    duration: '36 个月',
    budget: '550 万',
    progress: 50
  },
  {
    id: 8,
    code: '2025MAT002',
    name: '纳米材料在环境治理中的应用研究',
    leader: '周明',
    status: 'completed',
    currentStage: '任务书审查',
    currentStep: 2,
    stepStatus: 'completed',
    institution: '中山大学',
    startDate: '2025-01-20',
    duration: '30 个月',
    budget: '480 万',
    progress: 55
  },
  {
    id: 9,
    code: '2025MAT003',
    name: '石墨烯基柔性电子器件制备技术',
    leader: '吴强',
    status: 'inProgress',
    currentStage: '任务书审查',
    currentStep: 2,
    stepStatus: 'inProgress',
    institution: '西安交通大学',
    startDate: '2025-01-22',
    duration: '40 个月',
    budget: '680 万',
    progress: 48
  },
  // 中期审查 (Step 3)
  {
    id: 10,
    code: '2025ENE001',
    name: '高效太阳能电池材料研发',
    leader: '郑华',
    status: 'inProgress',
    currentStage: '中期审查',
    currentStep: 3,
    stepStatus: 'inProgress',
    institution: '哈尔滨工业大学',
    startDate: '2024-06-01',
    duration: '36 个月',
    budget: '600 万',
    progress: 60
  },
  {
    id: 11,
    code: '2025ENE002',
    name: '氢能源存储与转化技术研究',
    leader: '钱进',
    status: 'completed',
    currentStage: '中期审查',
    currentStep: 3,
    stepStatus: 'completed',
    institution: '天津大学',
    startDate: '2024-05-15',
    duration: '42 个月',
    budget: '750 万',
    progress: 65
  },
  {
    id: 12,
    code: '2025ENE003',
    name: '风能发电系统优化控制研究',
    leader: '李梅',
    status: 'inProgress',
    currentStage: '中期审查',
    currentStep: 3,
    stepStatus: 'inProgress',
    institution: '东南大学',
    startDate: '2024-07-01',
    duration: '36 个月',
    budget: '580 万',
    progress: 58
  },
  // 年度审查 (Step 4)
  {
    id: 13,
    code: '2025AI004',
    name: '智能推荐算法在电商平台的优化',
    leader: '张志强',
    status: 'inProgress',
    currentStage: '年度审查',
    currentStep: 4,
    stepStatus: 'inProgress',
    institution: '北京航空航天大学',
    startDate: '2024-03-01',
    duration: '36 个月',
    budget: '520 万',
    progress: 75
  },
  {
    id: 14,
    code: '2025AI005',
    name: '区块链技术在供应链管理中的应用',
    leader: '刘晓华',
    status: 'completed',
    currentStage: '年度审查',
    currentStep: 4,
    stepStatus: 'completed',
    institution: '西北工业大学',
    startDate: '2024-02-15',
    duration: '30 个月',
    budget: '450 万',
    progress: 80
  },
  {
    id: 15,
    code: '2025BIO004',
    name: '微生物发酵工程优化研究',
    leader: '陈明',
    status: 'inProgress',
    currentStage: '年度审查',
    currentStep: 4,
    stepStatus: 'inProgress',
    institution: '四川大学',
    startDate: '2024-04-01',
    duration: '42 个月',
    budget: '680 万',
    progress: 72
  },
  // 结题报告审查 (Step 5)
  {
    id: 16,
    code: '2025MAT004',
    name: '超导材料制备与应用研究',
    leader: '王丽',
    status: 'inProgress',
    currentStage: '结题报告审查',
    currentStep: 5,
    stepStatus: 'inProgress',
    institution: '兰州大学',
    startDate: '2023-01-01',
    duration: '36 个月',
    budget: '900 万',
    progress: 90
  },
  {
    id: 17,
    code: '2025MAT005',
    name: '智能材料在航空航天中的应用',
    leader: '李明',
    status: 'completed',
    currentStage: '结题报告审查',
    currentStep: 5,
    stepStatus: 'completed',
    institution: '国防科技大学',
    startDate: '2022-12-01',
    duration: '40 个月',
    budget: '950 万',
    progress: 95
  },
  {
    id: 18,
    code: '2025ENE004',
    name: '核能安全监测技术研究',
    leader: '张华',
    status: 'inProgress',
    currentStage: '结题报告审查',
    currentStep: 5,
    stepStatus: 'inProgress',
    institution: '中国科学技术大学',
    startDate: '2023-02-01',
    duration: '36 个月',
    budget: '880 万',
    progress: 92
  }
]

// 项目详细时间线数据
export const projectTimelineDetails = {
  1: {
    timeline: [
      {
        key: 'declaration',
        name: '申报书审查',
        description: '对项目申报书进行全方位合规性审查',
        status: 'completed',
        date: '2025-01-15',
        operator: '系统管理员',
        details: [
          { label: '与指南一致性分析', completed: true, value: '已通过' },
          { label: '申报书内容查重', completed: true, value: '相似度 12%' },
          { label: '科研诚信核查', completed: true, value: '无异常' },
          { label: '申报书格式审查', completed: true, value: '符合规范' }
        ]
      },
      {
        key: 'approval',
        name: '立项评审',
        description: '对项目进行深度内容评审和专家匹配',
        status: 'completed',
        date: '2025-02-01',
        operator: '评审专家组',
        details: [
          { label: '内容评审', completed: true, value: '综合评分 85 分' },
          { label: '专家遴选', completed: true, value: '已匹配 5 位专家' },
          { label: '评审意见', completed: true, value: '建议立项' }
        ]
      },
      {
        key: 'task',
        name: '任务书审查',
        description: '对比任务书与指南/立项合同的一致性',
        status: 'inProgress',
        date: null,
        operator: null,
        details: [
          { label: '任务书与指南对比', completed: true, value: '无修改' },
          { label: '指标合理性审查', completed: false, value: '待审核' },
          { label: '经费预算审查', completed: false, value: '待审核' }
        ]
      },
      {
        key: 'midterm',
        name: '中期审查',
        description: '检查项目中期执行情况和经费使用',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'annual',
        name: '年度审查',
        description: '年度执行情况和成果评估',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'final',
        name: '结题审查',
        description: '项目最终验收和成果审查',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      }
    ]
  },
  2: {
    timeline: [
      {
        key: 'declaration',
        name: '申报书审查',
        description: '对项目申报书进行全方位合规性审查',
        status: 'completed',
        date: '2025-01-20',
        operator: '系统管理员',
        details: [
          { label: '与指南一致性分析', completed: true, value: '已通过' },
          { label: '申报书内容查重', completed: true, value: '相似度 8%' },
          { label: '科研诚信核查', completed: true, value: '无异常' }
        ]
      },
      {
        key: 'approval',
        name: '立项评审',
        description: '对项目进行深度内容评审和专家匹配',
        status: 'inProgress',
        date: null,
        operator: null,
        details: [
          { label: '内容评审', completed: true, value: '综合评分 88 分' },
          { label: '专家遴选', completed: false, value: '进行中' }
        ]
      },
      {
        key: 'task',
        name: '任务书审查',
        description: '对比任务书与指南/立项合同的一致性',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'midterm',
        name: '中期审查',
        description: '检查项目中期执行情况和经费使用',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'annual',
        name: '年度审查',
        description: '年度执行情况和成果评估',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'final',
        name: '结题审查',
        description: '项目最终验收和成果审查',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      }
    ]
  },
  3: {
    timeline: [
      {
        key: 'declaration',
        name: '申报书审查',
        description: '对项目申报书进行全方位合规性审查',
        status: 'inProgress',
        date: null,
        operator: null,
        details: [
          { label: '与指南一致性分析', completed: true, value: '已通过' },
          { label: '申报书内容查重', completed: false, value: '审核中' }
        ]
      },
      {
        key: 'approval',
        name: '立项评审',
        description: '对项目进行深度内容评审和专家匹配',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'task',
        name: '任务书审查',
        description: '对比任务书与指南/立项合同的一致性',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'midterm',
        name: '中期审查',
        description: '检查项目中期执行情况和经费使用',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'annual',
        name: '年度审查',
        description: '年度执行情况和成果评估',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      },
      {
        key: 'final',
        name: '结题审查',
        description: '项目最终验收和成果审查',
        status: 'pending',
        date: null,
        operator: null,
        details: null
      }
    ]
  }
}

// 为其他项目生成默认时间线数据
for (let i = 4; i <= 18; i++) {
  const project = projects.find(p => p.id === i)
  if (project) {
    const currentStep = project.currentStep
    const timeline = []
    const steps = ['declaration', 'approval', 'task', 'midterm', 'annual', 'final']
    const stepNames = ['申报书审查', '立项评审', '任务书审查', '中期审查', '年度审查', '结题报告审查']
    
    steps.forEach((stepKey, index) => {
      let status = 'pending'
      let details = null
      let date = null
      let operator = null
      let description = ''
      
      if (index < currentStep) {
        status = 'completed'
        date = `2025-0${index + 1}-${10 + index * 5}`
        operator = '评审专家组'
        details = [
          { label: '审查项目', completed: true, value: '已通过' },
          { label: '评审得分', completed: true, value: `${80 + index * 2}分` }
        ]
      } else if (index === currentStep) {
        status = project.status === 'completed' ? 'completed' : 'inProgress'
        if (project.status === 'completed') {
          date = `2025-0${index + 1}-${15 + index * 5}`
          operator = '评审专家组'
          details = [
            { label: '审查项目', completed: true, value: '已通过' },
            { label: '评审得分', completed: true, value: `${85 + index * 2}分` }
          ]
        } else {
          details = [
            { label: '审查中', completed: false, value: '待处理' }
          ]
        }
      }
      
      switch(stepKey) {
        case 'declaration':
          description = '对项目申报书进行全方位合规性审查'
          break
        case 'approval':
          description = '对项目进行深度内容评审和专家匹配'
          break
        case 'task':
          description = '对比任务书与指南/立项合同的一致性'
          break
        case 'midterm':
          description = '检查项目中期执行情况和经费使用'
          break
        case 'annual':
          description = '年度执行情况和成果评估'
          break
        case 'final':
          description = '项目最终验收和成果审查'
          break
      }
      
      timeline.push({
        key: stepKey,
        name: stepNames[index],
        description,
        status,
        date,
        operator,
        details
      })
    })
    
    projectTimelineDetails[i] = { timeline }
  }
}

export default { projects, projectTimelineDetails }
